<template>
  <b-card no-body>
    <b-card-header header-bg-variant="primary" header-text-variant="white" v-b-toggle.collapse-exercice
                   class="text-center exercice-toggle"><b>Voir le sujet:</b>
      {{ exercice.title }}
    </b-card-header>
    <b-collapse id="collapse-exercice" class="mt-2">
      <b-card-body>
        <exercice-view :exercice="exercice">
          <template #titre>
            <div></div>
          </template>
          <template #type>
            <div></div>
          </template>
          <template #contenu="{contenu}">
            <div v-html="contenu"></div>
          </template>
          <template #contenu_cache="{contenu_cache}" v-if="isTeacher()">
            <hr>
            <b>Correction</b>
            <div v-html="contenu_cache"></div>
          </template>
        </exercice-view>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {Auth} from "@/js/caller";
import ExerciceView from "@/components/exerciceView";

export default {
  name      : "exerciceDisplay",
  components: {ExerciceView},
  props     : {exercice: [Number, Object]},
  methods   : {
    isTeacher() {
      return Auth.IsTeacher();
    }
  },
  created() {
    console.log(this.exercice);
  }
}
</script>

<style scoped>
.card {
  margin: 1rem;
}

.exercice-toggle.collapsed::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.exercice-toggle.not-collapsed::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
</style>